import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/utils/storage.service';

/**
  * @author Ministerio de cultura
  * @createdate 2024-10-14
  * Interceptor que se encarga precargar el token en las cabeceras HTTP.
*/
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private storage: StorageService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const starageKey: string = 'token';
		const storageType = 'local';
    const token = this.storage.get<any>(starageKey, storageType);
    if (token) {
      const requestWithJwt = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
      return next.handle(requestWithJwt);
    }
    return next.handle(request);
  }
}